import {
  Container,
  Title,
  Text,
  Button,
  Group,
  Paper,
  ThemeIcon,
  Stack,
} from "@mantine/core";
import { IconShieldLock, IconArrowLeft, IconLock } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

const UnauthorizedAccess = () => {
  const navigate = useNavigate();

  return (
    <Container size="md" py={80}>
      <Paper
        radius="md"
        p="xl"
        withBorder
        style={{
          backgroundColor: "var(--mantine-color-body)",
          textAlign: "center",
        }}
      >
        <Stack align="center" gap="lg">
          <ThemeIcon
            size={80}
            radius="100%"
            variant="light"
            color="orange"
            style={{ border: "2px solid var(--mantine-color-orange-2)" }}
          >
            <IconShieldLock size={40} style={{ opacity: 0.8 }} />
          </ThemeIcon>

          <div>
            <Group justify="center" gap="xs" mb="xs">
              <IconLock size={16} color="var(--mantine-color-dimmed)" />
              <Text
                c="dimmed"
                size="xs"
                tt="uppercase"
                fw={700}
                style={{ letterSpacing: 1.5 }}
              >
                Access Restricted
              </Text>
            </Group>

            <Title order={2} size="h1" fw={900} mb="xs">
              This area is off limits
            </Title>

            <Text c="dimmed" maw={500} mx="auto" size="lg">
              You don't have the necessary permissions to view this content. If
              you believe this is a mistake, please contact your administrator.
            </Text>
          </div>

          <Group justify="center" mt="md">
            <Button
              variant="default"
              leftSection={<IconArrowLeft size={16} />}
              onClick={() => navigate(-1)}
              size="md"
            >
              Go Back
            </Button>
            <Button
              variant="light"
              color="orange"
              onClick={() => navigate("/d")}
              size="md"
            >
              Dashboard Overview
            </Button>
          </Group>
        </Stack>
      </Paper>
    </Container>
  );
};

export default UnauthorizedAccess;
